// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};


console.log("FIREBASE projectId =", process.env.REACT_APP_PROJECT_ID);
console.log("FIREBASE authDomain =", process.env.REACT_APP_AUTH_DOMAIN);

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Analytics（建议加保护，避免生产炸站）
let analytics = null;
try {
  if (process.env.REACT_APP_MEASUREMENT_ID) {
    analytics = getAnalytics(app);
  }
} catch (e) {
  // ignore analytics errors
}

const auth = getAuth(app);
const db = getFirestore(app);
const provider = new GoogleAuthProvider();

export { app, analytics, auth, db, provider };
